import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import {
  fetchTopLinkDetails,
  clearTopLinkDetails,
} from 'redux/analytics/actions';

import ChartItem from 'components/dashboard/analytics-content/AnalyticsActivityCharts/ChartItem';

import './AnalyticsTopLinksDetails.css';

const AnalyticsTopLinksDetails = ({
  linkId,
  linkType,
  date,
  topLinkDetails,
  topLinkDetailsError,
  fetchTopLinkDetails,
  clearTopLinkDetails,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    fetchTopLinkDetails(linkId, linkType, date);
    return () => clearTopLinkDetails();
  }, [linkId, linkType, date]);

  if (!topLinkDetails || topLinkDetailsError) {
    return null;
  }

  if (topLinkDetails && Object.keys(topLinkDetails).length === 0) {
    return t("Looks like you have no data to display yet…");
  }

  const renderChartData = () => {
    const _data = Object.keys(topLinkDetails).map(i => ({
      date: i,
      value: topLinkDetails[i],
    }));
    return (
      <ChartItem compact chartData={_data} color="57, 58, 167" header="" type="clicks" sum />
    );
  };

  return (
    <div className="analytics-top-links-details__component">
      {renderChartData()}
    </div>
  );
};

AnalyticsTopLinksDetails.propTypes = {
  linkId: PropTypes.number,
  linkType: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fetchTopLinkDetails: PropTypes.func.isRequired,
  clearTopLinkDetails: PropTypes.func.isRequired,
  topLinkDetails: PropTypes.oneOfType([PropTypes.object]),
  topLinkDetailsError: PropTypes.oneOfType([PropTypes.object]),
};
AnalyticsTopLinksDetails.defaultProps = {
  linkId: null,
  linkType: null,
  topLinkDetails: null,
  topLinkDetailsError: null,
};

const mapStateToProps = state => ({
  topLinkDetails: state.analyticsReducer.topLinkDetails,
  topLinkDetailsError: state.analyticsReducer.topLinkDetailsError,
});

export default connect(
  mapStateToProps,
  {
    fetchTopLinkDetails,
    clearTopLinkDetails,
  },
)(AnalyticsTopLinksDetails);
